import { useId } from 'react';

interface ApiIconProps {
    className?: string;
}

export default function ApiIcon({ className = 'w-6 h-6' }: ApiIconProps) {
    const rawId = useId();
    const id = rawId.replace(/:/g, '');
    const gradient1Id = `${id}-linear-gradient`;
    const gradient2Id = `${id}-linear-gradient-2`;
    const gradient3Id = `${id}-linear-gradient-3`;
    const gradient4Id = `${id}-linear-gradient-4`;

    return (
        <svg
            id="Layer_2"
            data-name="Layer 2"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 283.15 189.77"
            className={className}
        >
            <defs>
                <linearGradient
                    id={gradient1Id}
                    x1="150.33"
                    y1="77.75"
                    x2="150.33"
                    y2="218.24"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#7a3fe8" />
                    <stop offset="1" stopColor="#220a4a" />
                </linearGradient>
                <linearGradient
                    id={gradient2Id}
                    x1="50.93"
                    y1="54.04"
                    x2="291.42"
                    y2="562.33"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset=".08" stopColor="#9362f4" />
                    <stop offset="1" stopColor="#3d157d" />
                </linearGradient>
                <linearGradient
                    id={gradient3Id}
                    x1="192.49"
                    y1="92.82"
                    x2="17.93"
                    y2="350.31"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#a86ff9" />
                    <stop offset="1" stopColor="#4a126f" />
                </linearGradient>
                <linearGradient
                    id={gradient4Id}
                    x1="139.91"
                    y1="138.66"
                    x2="184.77"
                    y2="437.05"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#c98dfb" />
                    <stop offset="1" stopColor="#5a127a" />
                </linearGradient>
            </defs>
            <g id="Layer_1-2" data-name="Layer 1">
                <g>
                    <circle
                        fill={`url(#${gradient1Id})`}
                        cx="150.33"
                        cy="79.99"
                        r="79.99"
                    />
                    <path
                        fill={`url(#${gradient2Id})`}
                        d="M153.85,92.01c2.29,1.42,4.58,2.83,6.87,4.24L28.45,157.99l-13.1,6.12C5.75,152.25,0,137.14,0,120.7,0,82.55,30.93,51.62,69.08,51.62c14.84,0,28.58,4.68,39.84,12.65.05.03.09.06.14.09,14.93,9.21,29.86,18.43,44.79,27.65Z"
                    />
                    <path
                        fill={`url(#${gradient3Id})`}
                        d="M283.13,129.46c.36,13.31-3.72,25.65-10.86,35.65-.01.02-.03.04-.04.06-.4.55-.8,1.1-1.22,1.63-.42.56-.86,1.11-1.31,1.65-.45.54-.9,1.07-1.36,1.59l-.02.02c-.45.51-.91,1.01-1.38,1.5-.01.02-.03.03-.04.04-.44.46-.89.91-1.34,1.36-.11.1-.21.2-.31.3-.43.42-.88.84-1.33,1.25-.01.01-.02.02-.04.03-.52.47-1.05.94-1.58,1.39-.53.44-1.07.88-1.61,1.31-.01,0-.02.01-.03.02-.45.35-.91.7-1.37,1.04-.21.16-.42.31-.63.46-.08.06-.15.11-.23.17-.93.66-1.89,1.3-2.86,1.9-.07.05-.13.09-.2.13-.56.35-1.13.69-1.7,1.02-.01,0-.01.01-.02.01-.56.32-1.13.64-1.7.94-.8.43-1.61.83-2.43,1.22-.48.23-.96.45-1.45.67-.09.03-.17.07-.25.11-.61.26-1.23.51-1.85.76,0,.01-.03.02-.06.02-1,.4-2.02.76-3.05,1.1-.32.11-.64.21-.96.31-.45.14-.92.28-1.38.41-.47.14-.93.26-1.4.38-.59.15-1.17.3-1.77.43-.33.07-.67.14-1,.21-.05.01-.1.03-.15.04-.45.09-.9.17-1.36.25-.48.09-.97.17-1.45.24-.4.07-.81.12-1.21.17-.36.05-.73.1-1.09.14-.34.04-.68.07-1.02.1-1.85.18-3.72.27-5.62.27H74.25c-.73,0-1.45-.02-2.17-.05-.11,0-.23-.01-.35-.01-.87.04-1.76.06-2.65.06-6.56,0-12.91-.91-18.92-2.62-13.87-3.94-25.97-12.11-34.81-23.04l13.1-6.12,132.27-61.74c11.6-5.42,23.2-10.83,34.8-16.25,8.75-4.97,18.9-7.76,29.72-7.61,31.28.41,57.05,25.81,57.89,57.08Z"
                    />
                    <path
                        fill={`url(#${gradient4Id})`}
                        d="M272.27,165.12s-.03.04-.04.06c-.4.55-.8,1.1-1.22,1.63-.42.56-.86,1.11-1.31,1.65-.45.54-.9,1.07-1.36,1.59l-.02.02c-.45.51-.91,1.01-1.38,1.5-.01.02-.03.03-.04.04-.44.46-.89.91-1.34,1.36-.11.1-.21.2-.31.3-.43.42-.88.84-1.33,1.25-.01.01-.02.02-.04.03-.52.47-1.05.94-1.58,1.39-.53.44-1.07.88-1.61,1.31-.01,0-.02.01-.03.02-.45.35-.91.7-1.37,1.04-.21.16-.42.31-.63.46-.08.06-.15.11-.23.17-.93.66-1.89,1.3-2.86,1.9-.07.05-.13.09-.2.13-.56.35-1.13.69-1.7,1.02-.01,0-.01.01-.02.01-.53.3-1.06.6-1.59.88-.04.02-.07.04-.11.06-.4.22-.8.42-1.21.62-.4.21-.8.4-1.21.6h-.01c-.48.23-.96.45-1.45.67-.09.03-.17.07-.25.11-.61.26-1.23.51-1.85.76,0,.01-.03.02-.06.02-.5.2-1,.39-1.51.57-.51.19-1.03.36-1.54.53-.32.11-.64.21-.96.31-.23.07-.45.14-.69.21-.23.07-.46.14-.69.2-.47.14-.93.26-1.4.38-.59.15-1.17.3-1.77.43-.03,0-.05,0-.08.02-.3.06-.62.13-.92.19-.05.01-.1.03-.15.04-.09.02-.19.04-.28.05-.36.07-.71.14-1.08.2-.48.09-.97.17-1.45.24-.4.07-.81.12-1.21.17-.32.04-.64.09-.96.12-.04.01-.09.02-.13.02-.34.04-.68.07-1.02.1-1.85.18-3.72.27-5.62.27H74.25c-.73,0-1.45-.02-2.17-.05-.11,0-.23-.01-.35-.01-.87.04-1.76.06-2.65.06-6.56,0-12.91-.91-18.92-2.62-.87-.25-1.73-.51-2.58-.79-.37-.12-.74-.24-1.1-.37-1.09-.38-2.17-.78-3.23-1.21-.34-.13-.68-.27-1.01-.42-1.13-.47-2.24-.97-3.33-1.51-.37-.18-.75-.37-1.12-.55-7.13-3.63-13.54-8.46-18.97-14.22-.28-.29-.55-.58-.82-.88-.91-1-1.8-2.03-2.65-3.09l13.1-6.12,132.27-61.74c3.96,2.44,7.91,4.89,11.87,7.33l97.14,59.97c.85.52,1.69,1.05,2.54,1.57Z"
                    />
                </g>
            </g>
        </svg>
    );
}
